export enum LogLevel {
  OFF,
  ERROR,
  WARNING,
  INFO,
  DEBUG,
}
